<div class="wiz-style">
  <h2 class="card-header header-background">Wizard</h2>
  <div #wizard class="wizard wizard-1" id="kt_wizard_v1" data-wizard-state="step-first" data-wizard-clickable="true">
    <div class="wizard-nav border-bottom">
      <div class="wizard-steps p-8 p-lg-10 wizard-steps-style">
        <div class="wizard-step" [class.active]="currentPage === 1 || currentPage === 2 || currentPage === 3">
          <div class="wizard-label-wrapper">
            <a href="javascript:;" class="wizard-label" data-wizard-type="step" data-wizard-state="current">
              <img class="wizard-img" [ngClass]="{ 'active-svg': currentPage >= 1 }" src="../../../../assets/media/menu-icons/wizard/Wizard-04.svg" alt="Incomer Details" />
              <h3 class="wizard-title">Incomer Details</h3>
            </a>
          </div>
        </div>
        <div class="wizard-step" [class.active]="currentPage === 2 || currentPage === 3">
          <div class="wizard-label-wrapper">
            <a href="javascript:;" class="wizard-label" data-wizard-type="step">
              <img class="wizard-img" [ngClass]="{ 'active-svg': currentPage >= 2 }" src="../../../../assets/media/menu-icons/wizard/Wizard-03.svg" alt="Outgoing Details" />
              <h3 class="wizard-title">Outgoing Details</h3>
            </a>
          </div>
        </div>
        <div class="wizard-step" [class.active]="currentPage === 3">
          <div class="wizard-label-wrapper">
            <a href="javascript:;" class="wizard-label" data-wizard-type="step">
              <img class="wizard-img" [ngClass]="{ 'active-svg': currentPage >= 3 }" src="../../../../assets/media/menu-icons/wizard/Wizard-02.svg" alt="Project Details" />
              <h3 class="wizard-title">Project Details</h3>
            </a>
          </div>
        </div>
        <div class="main-line">
          <div class="wizard-line" [class.completed]="currentPage >= 2"></div>
          <div class="wizard-line" [class.completed]="currentPage === 3"></div>
        </div>
      </div>
    </div>
    <div *ngIf="!showMCCB && !showProjectDetails">
      <div class="styles-css" [ngClass]="{ 'animated-slide-right': animateNext, 'animated-slide-left': animatePrevious }">
        <div class="divide-option">
          <div class="first-option">
            <div class="form-container">
              <p class="title-tire">Select Details of Incomer Tier - Incomer {{ currentIncomerPage }}</p>
              <div class="left-section">
                <div mat-dialog-content class="dialog-content">
                  <mat-radio-group [(ngModel)]="selectedItem" aria-label="Select an option">
                    <mat-radio-button [value]="'selectedAcb'">ACB</mat-radio-button>
                    <mat-radio-button [value]="'selectedmccb'">MCCB</mat-radio-button>
                  </mat-radio-group>

                  <!-- Form fields on the left side -->
                  <div class="form-field" *ngIf="selectedItem === 'selectedAcb'">
                    <mat-form-field id="custom-mat-field" appearance="outline">
                      <mat-label>Manufacturer</mat-label>
                      <mat-select [(value)]="selectedManufacturer" (selectionChange)="onSelectionChange()">
                        <mat-option *ngFor="let option of manufacturerOptions.reverse()" [value]="option">{{ option }}</mat-option>
                      </mat-select>
                    </mat-form-field>
                  </div>
                  <div class="form-field" *ngIf="selectedItem === 'selectedmccb'">
                    <mat-form-field id="custom-mat-field" appearance="outline">
                      <mat-label>Manufacturer</mat-label>
                      <mat-select [(value)]="selectedManufacturerMCCB" (selectionChange)="onSelectionChangeMCCB()">
                        <mat-option *ngFor="let option of manufacturerOptionsMCCB" [value]="option">{{ option }}</mat-option>
                      </mat-select>
                    </mat-form-field>
                  </div>

                  <div class="form-field" *ngIf="selectedItem === 'selectedAcb'">
                    <mat-form-field id="custom-mat-field" appearance="outline">
                      <mat-label>Rated Amp</mat-label>
                      <mat-select [(value)]="selectedRatedAmp" (selectionChange)="onSelectionChange()">
                        <mat-option *ngFor="let option of ratedAmpOptions" [value]="option">{{ option }}</mat-option>
                      </mat-select>
                    </mat-form-field>
                  </div>
                  <div class="form-field" *ngIf="selectedItem === 'selectedmccb'">
                    <mat-form-field id="custom-mat-field" appearance="outline">
                      <mat-label>Rated Amp</mat-label>
                      <mat-select [(value)]="selectedRatedAmpMCCB" (selectionChange)="onSelectionChangeMCCB()">
                        <mat-option *ngFor="let option of ratedAmpOptionsMCCB" [value]="option">{{ option }}</mat-option>
                      </mat-select>
                    </mat-form-field>
                  </div>
                  <div class="form-field" *ngIf="selectedItem === 'selectedAcb'">
                    <mat-form-field id="custom-mat-field" appearance="outline">
                      <mat-label>Type</mat-label>
                      <mat-select [(value)]="selectedType" (selectionChange)="onSelectionChange()">
                        <mat-option *ngFor="let option of typeOptions.reverse()" [value]="option">{{ option }}</mat-option>
                      </mat-select>
                    </mat-form-field>
                  </div>
                  <div class="form-field" *ngIf="selectedItem === 'selectedmccb'">
                    <mat-form-field id="custom-mat-field" appearance="outline">
                      <mat-label>Type</mat-label>
                      <mat-select [(value)]="selectedTypeMCCB" (selectionChange)="onSelectionChangeMCCB()">
                        <mat-option *ngFor="let option of typeOptionsMCCB.reverse()" [value]="option">{{ option }}</mat-option>
                      </mat-select>
                    </mat-form-field>
                  </div>
                  <div class="form-field" *ngIf="selectedItem === 'selectedAcb'">
                    <mat-form-field id="custom-mat-field" appearance="outline">
                      <mat-label>Frame Size</mat-label>
                      <mat-select [(value)]="selectedFrameSize" (selectionChange)="onSelectionChange()">
                        <mat-option *ngFor="let option of frameSizeOptions.reverse()" [value]="option">{{ option }}</mat-option>
                      </mat-select>
                    </mat-form-field>
                  </div>
                  <div class="form-field" *ngIf="selectedItem === 'selectedmccb'">
                    <mat-form-field id="custom-mat-field" appearance="outline">
                      <mat-label>Frame Size</mat-label>
                      <mat-select [(value)]="selectedFrameSizeMCCB" (selectionChange)="onSelectionChangeMCCB()">
                        <mat-option *ngFor="let option of frameSizeOptionsMCCB.reverse()" [value]="option">{{ option }}</mat-option>
                      </mat-select>
                    </mat-form-field>
                  </div>
                  <div class="form-field">
                    <mat-form-field id="custom-mat-field" appearance="outline" *ngIf="selectedItem === 'selectedAcb'">
                      <mat-label>PRF Level</mat-label>
                      <mat-select [(value)]="selectedPRFLevel" (selectionChange)="onSelectionChange()">
                        <mat-option *ngFor="let option of prfLevelOptions.reverse()" [value]="option">{{ option }}</mat-option>
                      </mat-select>
                    </mat-form-field>
                  </div>
                  <div class="form-field" *ngIf="selectedItem === 'selectedmccb'">
                    <mat-form-field id="custom-mat-field" appearance="outline">
                      <mat-label>PRF Level</mat-label>
                      <mat-select [(value)]="selectedPRFLevelMCCB" (selectionChange)="onSelectionChangeMCCB()">
                        <mat-option *ngFor="let option of prfLevelOptionsMCCB.reverse()" [value]="option">{{ option }}</mat-option>
                      </mat-select>
                    </mat-form-field>
                  </div>
                  <div class="form-field" *ngIf="selectedItem === 'selectedmccb'">
                    <mat-label>Minimum Height for Terminals-mm</mat-label>
                    <mat-radio-group [(ngModel)]="selectedMinHeightApplication" (change)="onSelectionChangeMCCB()">
                      <mat-radio-button [value]="'1C Applications'">1C Applications</mat-radio-button>
                      <mat-radio-button [value]="'4C Applications'">4C Applications</mat-radio-button>
                    </mat-radio-group>
                  </div>
                </div>
              </div>
              <div class="middle-section" *ngIf="selectedItem === 'selectedAcb'">
                <div mat-dialog-content class="dialog-content">
                  <!-- Form fields in the center -->
                  <div class="form-field">
                    <mat-form-field id="custom-mat-field" appearance="outline">
                      <mat-label>Short Circuit Icu</mat-label>
                      <mat-select [(value)]="selectedShortCircuitIcu" (selectionChange)="onSelectionChange()">
                        <mat-option *ngFor="let option of shortCircuitIcuOptions.reverse()" [value]="option">{{ option }}</mat-option>
                      </mat-select>
                    </mat-form-field>
                  </div>
                  <div class="form-field">
                    <mat-form-field id="custom-mat-field" appearance="outline">
                      <mat-label>Busbar Type</mat-label>
                      <mat-select [(value)]="selectedBusbarType" (selectionChange)="onSelectionChange()">
                        <mat-option *ngFor="let option of busbarTypeOptions" [value]="option">{{ option }}</mat-option>
                      </mat-select>
                    </mat-form-field>
                  </div>
                  <div class="form-field">
                    <mat-form-field id="custom-mat-field" appearance="outline">
                      <mat-label>Cable Size (mm²)</mat-label>
                      <mat-select [(value)]="selectedCableSize" (selectionChange)="onSelectionChange()">
                        <mat-option *ngFor="let cable of cableSizeData" [value]="cable.size">{{ cable.size }}</mat-option>
                      </mat-select>
                    </mat-form-field>
                  </div>
                  <div class="form-field" *ngIf="currentIncomerPage === 1">
                    <mat-form-field id="custom-mat-field" appearance="outline">
                      <mat-label>Maximum Tier Height</mat-label>
                      <mat-select [(value)]="selectedMaxTierHeight">
                        <mat-option *ngFor="let option of maxTierHeightOptions" [value]="option">{{ option }}</mat-option>
                      </mat-select>
                    </mat-form-field>
                  </div>
                  <div class="form-style-css no-border">
                    <mat-label>Minimum Height for Terminals-mm</mat-label>
                    <mat-radio-group [(ngModel)]="selectedMinHeightApplication" (change)="onSelectionChange()">
                      <mat-radio-button [value]="'1C Applications'">1C Applications</mat-radio-button>
                      <mat-radio-button [value]="'4C Applications'">4C Applications</mat-radio-button>
                    </mat-radio-group>
                  </div>
                </div>
              </div>
              <div class="middle-section" *ngIf="selectedItem === 'selectedmccb'">
                <div mat-dialog-content class="dialog-content">
                  <!-- Form fields in the center -->
                  <div class="form-field">
                    <mat-form-field id="custom-mat-field" appearance="outline">
                      <mat-label>Short Circuit Icu</mat-label>
                      <mat-select [(value)]="selectedShortCircuitIcuMCCB" (selectionChange)="onSelectionChangeMCCB()">
                        <mat-option *ngFor="let option of shortCircuitIcuOptionsMCCB.reverse()" [value]="option">{{ option }}</mat-option>
                      </mat-select>
                    </mat-form-field>
                  </div>
                  <div class="form-field">
                    <mat-form-field id="custom-mat-field" appearance="outline">
                      <mat-label>Trip Unit</mat-label>
                      <mat-select [(value)]="selectedTripUnitMCCB" (selectionChange)="onSelectionChangeMCCB()">
                        <mat-option *ngFor="let option of tripUnitOptionsMCCB.reverse()" [value]="option">{{ option }}</mat-option>
                      </mat-select>
                    </mat-form-field>
                  </div>
                  <div class="form-field">
                    <mat-form-field id="custom-mat-field" appearance="outline">
                      <mat-label>Cable Size (mm²)</mat-label>
                      <mat-select [(value)]="selectedCableSize" (selectionChange)="onSelectionChangeMCCB()">
                        <mat-option *ngFor="let cable of cableSizeData" [value]="cable.size">{{ cable.size }}</mat-option>
                      </mat-select>
                    </mat-form-field>
                  </div>
                  <div class="form-field">
                    <mat-form-field id="custom-mat-field" appearance="outline">
                      <mat-label>Order Number</mat-label>
                      <mat-select [(value)]="selectedOrderNumberMCCB" (selectionChange)="onSelectionChangeMCCB()">
                        <mat-option *ngFor="let option of orderNumberOptionsMCCB.reverse()" [value]="option">{{ option }}</mat-option>
                      </mat-select>
                    </mat-form-field>
                  </div>
                  <div class="form-field" *ngIf="currentIncomerPage === 1">
                    <mat-form-field id="custom-mat-field" appearance="outline">
                      <mat-label>Maximum Tier Height</mat-label>
                      <mat-select [(value)]="selectedMaxTierHeight">
                        <mat-option *ngFor="let option of maxTierHeightOptions" [value]="option">{{ option }}</mat-option>
                      </mat-select>
                    </mat-form-field>
                  </div>
                  <div class="form-field">
                    <mat-form-field id="custom-mat-field" appearance="outline">
                      <mat-label>Busbar Type</mat-label>
                      <mat-select [(value)]="selectedBusbarType" (selectionChange)="onSelectionChangeMCCB()">
                        <mat-option *ngFor="let option of busbarTypeOptions" [value]="option">{{ option }}</mat-option>
                      </mat-select>
                    </mat-form-field>
                  </div>
                  <div class="form-style-css no-border">
                    <mat-label> Mounting Horizontal/Vertical</mat-label>
                    <mat-radio-group [(ngModel)]="selectedRotation" (change)="onSelectionChangeMCCB()">
                      <mat-radio-button value="Vertical">Vertical</mat-radio-button>
                      <mat-radio-button value="Horizontal">Horizontal</mat-radio-button>
                    </mat-radio-group>
                  </div>
                </div>
              </div>
              <div class="right-section" *ngIf="selectedItem === 'selectedAcb'">
                <div class="details-section">
                  <div class="details" *ngIf="matchingRow">
                    <h3 style="border-bottom: 1px solid">Details</h3>
                    <div class="img-made" *ngIf="matchingRow">
                      <img [src]="imagePath" alt="ACB Image" *ngIf="imagePath" class="image-css" />
                    </div>
                    <p><strong>Short Circuit Ics:</strong> {{ matchingRow["SHORTCU_(Ics)"] }}</p>
                    <p><strong>Short Circuit Icw:</strong> {{ matchingRow["SHORTCU_(Icw)"] }}</p>
                    <p><strong>Width:</strong> {{ matchingRow.WIDTH }}</p>
                    <p><strong>Height:</strong> {{ matchingRow.HEIGHT }}</p>
                    <p><strong>Depth:</strong> {{ matchingRow.DEPTH }}</p>
                    <p><strong>Watt Loss:</strong> {{ matchingRow.WATT_LOSS }}</p>
                    <p><strong>Weight:</strong> {{ matchingRow.WEIGHT }}</p>
                  </div>
                  <div class="details" *ngIf="!matchingRow">
                    <h3 style="border-bottom: 1px solid">Details</h3>
                    <div *ngIf="matchingRow">
                      <img class="img-made" [src]="imagePath" alt="ACB Image" *ngIf="imagePath" class="image-css" />
                    </div>
                    <p><strong>Short Circuit Ics:</strong> {{ "N/A" }}</p>
                    <p><strong>Short Circuit Icw:</strong> {{ "N/A" }}</p>
                    <p><strong>Width:</strong> {{ "N/A" }}</p>
                    <p><strong>Height:</strong> {{ "N/A" }}</p>
                    <p><strong>Depth:</strong> {{ "N/A" }}</p>
                    <p><strong>Watt Loss:</strong> {{ "N/A" }}</p>
                    <p><strong>Weight:</strong> {{ "N/A" }}</p>
                  </div>
                </div>
              </div>
              <div class="right-section" *ngIf="selectedItem === 'selectedmccb'">
                <div class="details-section">
                  <div class="details" *ngIf="matchingRowMCCB || !matchingRowMCCB">
                    <h3 style="border-bottom: 1px solid">Details</h3>
                    <div class="img-made" *ngIf="matchingRowMCCB">
                      <img [src]="matchingRowMCCB?.ImagePath" alt="ACB Image" *ngIf="matchingRowMCCB?.ImagePath" class="image-css" [class.rotate-90]="matchingRowMCCB?.ROTATION === 'Horizontal'" />
                    </div>
                    <p><strong>Width:</strong> {{ matchingRowMCCB?.WIDTH || "N/A" }}</p>
                    <p><strong>Height:</strong> {{ matchingRowMCCB?.HEIGHT || "N/A" }}</p>
                    <p><strong>Depth:</strong> {{ matchingRowMCCB?.DEPTH || "N/A" }}</p>
                    <p><strong>Watt Loss:</strong> {{ matchingRowMCCB?.WATT_LOSS || "N/A" }}</p>
                    <p><strong>Weight:</strong> {{ matchingRowMCCB?.WEIGHT || "N/A" }}</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div [ngClass]="{ 'animated-slide-right': animateNext, 'animated-slide-left': animatePrevious }" *ngIf="showMCCB">
      <div class="style-css" [ngClass]="{ 'animated-slide-right': animateNext, 'animated-slide-left': animatePrevious }">
        <div class="divide-option">
          <div class="first-option">
            <div class="form-container">
              <p class="title-tire">Select Details of Outgoing Tier - Outgoing {{ currentOutGoingPage }}</p>
              <div class="left-section">
                <div mat-dialog-content class="dialog-content">
                  <!-- Form fields on the left side -->
                  <div class="form-field">
                    <mat-form-field id="custom-mat-field" appearance="outline">
                      <mat-label>Manufacturer</mat-label>
                      <mat-select [(value)]="selectedManufacturerMCCB" (selectionChange)="onSelectionChangeMCCB()">
                        <mat-option *ngFor="let option of manufacturerOptionsMCCB" [value]="option">{{ option }}</mat-option>
                      </mat-select>
                    </mat-form-field>
                  </div>
                  <div class="form-field">
                    <mat-form-field id="custom-mat-field" appearance="outline">
                      <mat-label>Rated Amp</mat-label>
                      <mat-select [(value)]="selectedRatedAmpMCCB" (selectionChange)="onSelectionChangeMCCB()">
                        <mat-option *ngFor="let option of ratedAmpOptionsMCCB" [value]="option">{{ option }}</mat-option>
                      </mat-select>
                    </mat-form-field>
                  </div>
                  <div class="form-field">
                    <mat-form-field id="custom-mat-field" appearance="outline">
                      <mat-label>Type</mat-label>
                      <mat-select [(value)]="selectedTypeMCCB" (selectionChange)="onSelectionChangeMCCB()">
                        <mat-option *ngFor="let option of typeOptionsMCCB.reverse()" [value]="option">{{ option }}</mat-option>
                      </mat-select>
                    </mat-form-field>
                  </div>
                  <div class="form-field">
                    <mat-form-field id="custom-mat-field" appearance="outline">
                      <mat-label>Frame Size</mat-label>
                      <mat-select [(value)]="selectedFrameSizeMCCB" (selectionChange)="onSelectionChangeMCCB()">
                        <mat-option *ngFor="let option of frameSizeOptionsMCCB.reverse()" [value]="option">{{ option }}</mat-option>
                      </mat-select>
                    </mat-form-field>
                  </div>
                  <div class="form-field">
                    <mat-form-field id="custom-mat-field" appearance="outline">
                      <mat-label>PRF Level</mat-label>
                      <mat-select [(value)]="selectedPRFLevelMCCB" (selectionChange)="onSelectionChangeMCCB()">
                        <mat-option *ngFor="let option of prfLevelOptionsMCCB.reverse()" [value]="option">{{ option }}</mat-option>
                      </mat-select>
                    </mat-form-field>
                  </div>
                </div>
              </div>
              <div class="middle-section">
                <div mat-dialog-content class="dialog-content">
                  <!-- Form fields in the center -->
                  <div class="form-field">
                    <mat-form-field id="custom-mat-field" appearance="outline">
                      <mat-label>Short Circuit Icu</mat-label>
                      <mat-select [(value)]="selectedShortCircuitIcuMCCB" (selectionChange)="onSelectionChangeMCCB()">
                        <mat-option *ngFor="let option of shortCircuitIcuOptionsMCCB.reverse()" [value]="option">{{ option }}</mat-option>
                      </mat-select>
                    </mat-form-field>
                  </div>
                  <div class="form-field">
                    <mat-form-field id="custom-mat-field" appearance="outline">
                      <mat-label>Trip Unit</mat-label>
                      <mat-select [(value)]="selectedTripUnitMCCB" (selectionChange)="onSelectionChangeMCCB()">
                        <mat-option *ngFor="let option of tripUnitOptionsMCCB.reverse()" [value]="option">{{ option }}</mat-option>
                      </mat-select>
                    </mat-form-field>
                  </div>
                  <div class="form-field">
                    <mat-form-field id="custom-mat-field" appearance="outline">
                      <mat-label>Order Number</mat-label>
                      <mat-select [(value)]="selectedOrderNumberMCCB" (selectionChange)="onSelectionChangeMCCB()">
                        <mat-option *ngFor="let option of orderNumberOptionsMCCB.reverse()" [value]="option">{{ option }}</mat-option>
                      </mat-select>
                    </mat-form-field>
                  </div>
                  <div class="form-field">
                    <mat-form-field id="custom-mat-field" appearance="outline">
                      <mat-label> Number of Outgoing from this Type</mat-label>
                      <input matInput type="number" [(ngModel)]="numberOfOutgoing" name="numberOfOutgoing" required min="0" />
                    </mat-form-field>
                  </div>
                  <div class="form-style-css no-border">
                    <mat-label> Mounting Horizontal/Vertical</mat-label>
                    <mat-radio-group [(ngModel)]="selectedRotation" (change)="onSelectionChangeMCCB()">
                      <mat-radio-button value="Vertical">Vertical</mat-radio-button>
                      <mat-radio-button value="Horizontal">Horizontal</mat-radio-button>
                    </mat-radio-group>
                  </div>
                </div>
              </div>
              <div class="right-section">
                <div class="details-section">
                  <div class="details" *ngIf="matchingRowMCCB || !matchingRowMCCB">
                    <h3 style="border-bottom: 1px solid">Details</h3>
                    <div class="img-made" *ngIf="matchingRow">
                      <img [src]="imagePathMCCB" alt="ACB Image" *ngIf="imagePathMCCB" class="image-css" [class.rotate-90]="matchingRowMCCB?.ROTATION === 'Horizontal'" />
                    </div>
                    <p><strong>Width:</strong> {{ matchingRowMCCB?.WIDTH || "N/A" }}</p>
                    <p><strong>Height:</strong> {{ matchingRowMCCB?.HEIGHT || "N/A" }}</p>
                    <p><strong>Depth:</strong> {{ matchingRowMCCB?.DEPTH || "N/A" }}</p>
                    <p><strong>Watt Loss:</strong> {{ matchingRowMCCB?.WATT_LOSS || "N/A" }}</p>
                    <p><strong>Weight:</strong> {{ matchingRowMCCB?.WEIGHT || "N/A" }}</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div [ngClass]="{ 'animated-slide-right': animateNext, 'animated-slide-left': animatePrevious }" *ngIf="showProjectDetails">
      <form class="form" [formGroup]="projectForm">
        <div class="card-body style-css">
          <div class="sub-title-style">General Panel Details</div>
          <!-- <div class="card-body-progress">
            <mat-spinner [diameter]="20"></mat-spinner>
          </div> -->
          <div class="form-group row style-form">
            <div class="col-lg-6 kt-margin-bottom-20-mobile">
              <mat-form-field id="project" class="mat-form-field-fluid" appearance="outline">
                <mat-label>Project Title </mat-label>
                <input matInput placeholder="Enter Project Title" formControlName="title" maxlength="50" />
                <mat-error
                  >Title is
                  <strong>required</strong>
                </mat-error>
              </mat-form-field>
            </div>
            <div class="col-lg-3 kt-margin-bottom-20-mobile">
              <mat-form-field id="panelname" class="mat-form-field-fluid" appearance="outline">
                <mat-label>Panel Name</mat-label>

                <input matInput placeholder="Enter Panel Name" formControlName="panelname" />
                <mat-error
                  >Panel Name is
                  <strong>required</strong>
                </mat-error>
              </mat-form-field>
            </div>
            <div class="col-lg-3 kt-margin-bottom-20-mobile">
              <mat-form-field id="date" class="mat-form-field-fluid" appearance="outline">
                <mat-label>Date</mat-label>

                <input matInput [matDatepicker]="picker" formControlName="orginDate" />
                <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
                <mat-datepicker #picker></mat-datepicker>
                <mat-error
                  >Date is
                  <strong>required</strong>
                </mat-error>
              </mat-form-field>
            </div>
          </div>
          <div id="border-bottom" class="form-group row style-form">
            <div class="col-lg-3 kt-margin-bottom-20-mobile">
              <mat-form-field id="reference" class="mat-form-field-fluid" appearance="outline">
                <mat-label>Reference</mat-label>

                <input matInput placeholder="Enter Reference" formControlName="version" />
                <mat-error
                  >Reference is
                  <strong>required</strong>
                </mat-error>
              </mat-form-field>
            </div>
            <div class="col-lg-3 kt-margin-bottom-20-mobile">
              <mat-form-field id="approver" class="mat-form-field-fluid" appearance="outline">
                <mat-label>Approved By</mat-label>

                <input matInput placeholder="Enter Approver" formControlName="approvedBy" />
                <mat-error
                  >Approver is
                  <strong>required</strong>
                </mat-error>
              </mat-form-field>
            </div>
            <div class="col-lg-3 kt-margin-bottom-20-mobile">
              <mat-form-field id="designer" class="mat-form-field-fluid" appearance="outline">
                <mat-label>Designer</mat-label>

                <input matInput placeholder="Enter Designer" formControlName="designer" value="{{ userName }}" readonly />

                <mat-error
                  >Designer is
                  <strong>required</strong>
                </mat-error>
              </mat-form-field>
            </div>
          </div>
          <div class="sub-title-style">Client Details</div>
          <div class="form-group row style-form" formGroupName="customerName">
            <div class="col-lg-6 kt-margin-bottom-20-mobile">
              <mat-form-field id="client" class="mat-form-field-fluid">
                <mat-label>Client Name</mat-label>
                <input type="text" class="client-input" placeholder="Search for Customer" aria-label="Customer Name" matInput [formControl]="myControl" [matAutocomplete]="auto" [value]="displaySelectedCustomer(myControl.value) ? displaySelectedCustomer(myControl.value) : projectForm.get('customerName').value" (input)="onCustomerNameInput($event.target.value)" />

                <mat-autocomplete autoActiveFirstOption #auto="matAutocomplete" [displayWith]="displayFn" (optionSelected)="onCustomerSelected($event.option.value)">
                  <mat-option *ngFor="let customer of filteredCustomers | async" [value]="customer.uuid">
                    {{ customer.customername }}
                  </mat-option>
                </mat-autocomplete>

                <mat-error *ngIf="myControl.hasError('required')"> Client is <strong>required</strong> </mat-error>
              </mat-form-field>
            </div>
          </div>
          <div class="form-group row style-form" formGroupName="address">
            <div class="col-lg-6 kt-margin-bottom-20-mobile">
              <mat-form-field id="address" class="mat-form-field-fluid" appearance="outline">
                <mat-label>Address Line</mat-label>

                <input matInput placeholder="Enter Address" formControlName="addressLine" />
                <mat-error
                  >Address is
                  <strong>required</strong>
                </mat-error>
              </mat-form-field>
            </div>
            <div class="col-lg-3 kt-margin-bottom-20-mobile">
              <mat-form-field id="country" class="mat-form-field-fluid" appearance="outline">
                <mat-label>Country</mat-label>

                <input matInput placeholder="Enter Country" formControlName="country" />
              </mat-form-field>
            </div>
            <div class="col-lg-3 kt-margin-bottom-20-mobile">
              <mat-form-field class="mat-form-field-fluid" appearance="outline">
                <mat-label>Email ID</mat-label>
                <input matInput placeholder="Enter Email" formControlName="email" />
              </mat-form-field>
            </div>
          </div>
          <div class="form-group row style-form" formGroupName="address">
            <div class="col-lg-2 kt-margin-bottom-20-mobile">
              <mat-form-field id="city" class="mat-form-field-fluid" appearance="outline">
                <mat-label>City</mat-label>

                <input matInput placeholder="Enter City" formControlName="city" />
              </mat-form-field>
            </div>

            <div class="col-lg-2 kt-margin-bottom-20-mobile">
              <mat-form-field id="state" class="mat-form-field-fluid" appearance="outline">
                <mat-label>State</mat-label>

                <input matInput placeholder="Enter State" formControlName="state" />
              </mat-form-field>
            </div>
            <div class="col-lg-2 kt-margin-bottom-20-mobile">
              <mat-form-field id="postal" class="mat-form-field-fluid" appearance="outline">
                <mat-label>Postal</mat-label>

                <input matInput placeholder="Enter Postal Code" formControlName="postCode" />
              </mat-form-field>
            </div>
            <div class="col-lg-3 kt-margin-bottom-20-mobile">
              <mat-form-field id="telephone" class="mat-form-field-fluid" appearance="outline">
                <mat-label>Telephone</mat-label>

                <input matInput placeholder="Enter Telephone" formControlName="telephone" (input)="onTelephoneInput($event)" #telephoneInput />
                <mat-error
                  >Telephone is
                  <strong>required</strong>
                </mat-error>
              </mat-form-field>
            </div>
            <div class="col-lg-3 kt-margin-bottom-20-mobile">
              <mat-form-field id="mobile" class="mat-form-field-fluid" appearance="outline">
                <mat-label>Mobile</mat-label>

                <input matInput placeholder="Enter Mobile" formControlName="mobile" (input)="onTelephoneInput($event)" />
                <mat-error
                  >Mobile is
                  <strong>required</strong>
                </mat-error>
              </mat-form-field>
            </div>
          </div>
          <div id="border-bottom" class="form-group row style-form"></div>
          <div class="sub-title-style">Technical Specification | IEC Standard - 61439</div>
          <div class="form-group row style-form">
            <div class="col-lg-2 kt-margin-bottom-20-mobile">
              <mat-form-field class="mat-form-field-fluid" appearance="outline">
                <mat-label>Ampere rating</mat-label>

                <mat-select placeholder="Voltage" formControlName="voltage">
                  <mat-option value="">Choose Ampere rating</mat-option>
                  <mat-option *ngFor="let type of voltage" [value]="type">{{ type }}</mat-option>
                </mat-select>
                <mat-error
                  >Ampere rating is
                  <strong>required</strong>
                </mat-error>
              </mat-form-field>
            </div>
            <div class="col-lg-2 kt-margin-bottom-20-mobile">
              <mat-form-field class="mat-form-field-fluid" appearance="outline">
                <mat-label>Form Type</mat-label>
                <mat-select placeholder="Form Type" formControlName="formType">
                  <mat-option value="">Choose Form Type</mat-option>
                  <mat-option value="Form 1">Form 1</mat-option>
                  <mat-option value="Form 2a">Form 2a</mat-option>
                  <mat-option value="Form 2b">Form 2b</mat-option>
                  <mat-option value="Form 3a">Form 3a</mat-option>
                  <mat-option value="Form 3b">Form 3b</mat-option>

                  <!-- Grouping Form 4a Submenu -->
                  <mat-optgroup label="Form 4a">
                    <mat-option value="Form 4a Type 1">Form 4a Type 1</mat-option>
                    <mat-option value="Form 4a Type 2">Form 4a Type 2</mat-option>
                    <mat-option value="Form 4a Type 3">Form 4a Type 3</mat-option>
                  </mat-optgroup>

                  <!-- Grouping Form 4b Submenu -->
                  <mat-optgroup label="Form 4b">
                    <mat-option value="Form 4b Type 4">Form 4b Type 4</mat-option>
                    <mat-option value="Form 4b Type 5">Form 4b Type 5</mat-option>
                    <mat-option value="Form 4b Type 6">Form 4b Type 6</mat-option>
                  </mat-optgroup>
                </mat-select>
                <mat-error>Form Type is <strong>required</strong></mat-error>
              </mat-form-field>
            </div>
            <div class="col-lg-2 kt-margin-bottom-20-mobile">
              <mat-form-field class="mat-form-field-fluid" appearance="outline">
                <mat-label>Short Circuit Current</mat-label>

                <mat-select placeholder="Short Circuit Current" formControlName="shortCircuitTime">
                  <mat-option value="">Choose Short Circuit Time</mat-option>
                  <mat-option *ngFor="let type of shortCircuitTime" [value]="type">{{ type }}</mat-option>
                </mat-select>
                <mat-error
                  >Busbar Location is
                  <strong>required</strong>
                </mat-error>
              </mat-form-field>
            </div>
            <div class="col-lg-6 kt-margin-bottom-20-mobile">
              <mat-form-field class="mat-form-field-fluid" appearance="outline">
                <mat-label>Depth</mat-label>

                <mat-select placeholder="Depth option" formControlName="depthoption"
                  panelClass="depth-select-panel">
                  <mat-select-trigger *ngIf="projectForm.get('depthoption').value as d">
                    {{ d.component }} + {{ d.busbar }} = {{ d.total }} mm
                  </mat-select-trigger>
                  <mat-option value="">Choose depth </mat-option>
                  <mat-option *ngFor="let type of depth" [value]="type">Component: {{ type.component }} | Busbar: {{ type.busbar }} | Total: {{ type.total }}</mat-option>
                </mat-select>
                <mat-error
                  >Depth is
                  <strong>required</strong>
                </mat-error>
              </mat-form-field>
            </div>
            <div class="col-lg-2 kt-margin-bottom-20-mobile">
              <mat-form-field class="mat-form-field-fluid" appearance="outline">
                <mat-label>Ip Rating</mat-label>

                <mat-select placeholder="Ip Rating" formControlName="ipRating">
                  <mat-option value="">Choose Ip Rating</mat-option>
                  <mat-option *ngFor="let ipr of ipRating" [value]="ipr">{{ ipr }}</mat-option>
                </mat-select>
                <mat-error
                  >Ip Rating is
                  <strong>required</strong>
                </mat-error>
              </mat-form-field>
            </div>
            <div class="col-lg-2 kt-margin-bottom-20-mobile">
              <mat-form-field class="mat-form-field-fluid" appearance="outline">
                <mat-label>Earthing System</mat-label>

                <mat-select placeholder="Earthing System" formControlName="earthingSystem">
                  <mat-option value="">Choose Earthing System</mat-option>
                  <mat-option *ngFor="let es of earthingSystem" [value]="es">{{ es }}</mat-option>
                </mat-select>
                <mat-error
                  >Earthing System is
                  <strong>required</strong>
                </mat-error>
              </mat-form-field>
            </div>
            <div class="col-lg-2 kt-margin-bottom-20-mobile">
              <mat-form-field class="mat-form-field-fluid" appearance="outline">
                <mat-label>Colour</mat-label>

                <mat-select placeholder="Colour" formControlName="colour">
                  <mat-option value="">Choose Colour</mat-option>
                  <mat-option *ngFor="let col of colour" [value]="col">{{ col }}</mat-option>
                </mat-select>
                <mat-error
                  >Colour is
                  <strong>required</strong>
                </mat-error>
              </mat-form-field>
            </div>
            <div class="col-lg-3 kt-margin-bottom-20-mobile">
              <mat-form-field class="mat-form-field-fluid" appearance="outline">
                <mat-label>Busbar Location</mat-label>

                <mat-select placeholder="Busbar Location" formControlName="busbarLocation">
                  <mat-option value="">Choose Busbar Location</mat-option>
                  <mat-option *ngFor="let type of busbarLocation" [value]="type">{{ type }}</mat-option>
                </mat-select>
                <mat-error
                  >Busbar Location is
                  <strong>required</strong>
                </mat-error>
              </mat-form-field>
            </div>
            <div class="col-lg-3 kt-margin-bottom-20-mobile">
              <mat-form-field class="mat-form-field-fluid" appearance="outline">
                <mat-label>Cable Direction</mat-label>

                <mat-select placeholder="Cable Direction" formControlName="cabledirection">
                  <mat-option value="">Choose Cable Direction</mat-option>
                  <mat-option *ngFor="let type of cabledirection" [value]="type">{{ type }}</mat-option>
                </mat-select>
                <mat-error
                  >Cable Direction is
                  <strong>required</strong>
                </mat-error>
              </mat-form-field>
            </div>
            <div class="col-lg-3 kt-margin-bottom-20-mobile" style="display: none">
              <mat-form-field class="mat-form-field-fluid" appearance="outline">
                <mat-label>Iec Standard</mat-label>

                <mat-select placeholder="Earthing System" formControlName="iecStandard">
                  <mat-option value="">Choose Earthing System</mat-option>
                  <mat-option *ngFor="let iecs of iecStandard" [value]="iecs">{{ iecs }}</mat-option>
                </mat-select>
                <mat-error
                  >Iec Standard is
                  <strong>required</strong>
                </mat-error>
              </mat-form-field>
            </div>
          </div>
        </div>
      </form>
    </div>
    <div *ngIf="!showMCCB && !showProjectDetails" class="button-container">
      <button mat-raised-button style="background-color: #183160; color: white" (click)="previousIncomer()" *ngIf="incomerHistory.length > 0 && currentIncomerPage !== 1" [disabled]="incomerHistory.length <= 0">
        <span class="p-button-icon p-button-icon-left fas fa-backward"></span>
        Previous Incomer
      </button>
      <button *ngIf="selectedItem === 'selectedAcb'" mat-raised-button style="background-color: #34bc83; color: white" (click)="addIncomer()" [disabled]="!matchingRow || (!selectedMaxTierHeight && currentIncomerPage === 1)"><span class="fa-solid fa-circle-plus"></span> Add Another Incomer</button>
      <button *ngIf="selectedItem === 'selectedmccb'" mat-raised-button style="background-color: #34bc83; color: white" (click)="addIncomer()" [disabled]="!matchingRowMCCB || (!selectedMaxTierHeight && currentIncomerPage === 1)"><span class="fa-solid fa-circle-plus"></span> Add Another Incomer</button>
      <button *ngIf="selectedItem === 'selectedAcb'" mat-raised-button color="primary" (click)="next()" [disabled]="!matchingRow || (!selectedMaxTierHeight && currentIncomerPage === 1)">Next <span class="p-button-icon p-button-icon-left fas fa-forward"></span></button>
      <button *ngIf="selectedItem === 'selectedmccb'" mat-raised-button color="primary" (click)="next()" [disabled]="!matchingRowMCCB || (!selectedMaxTierHeight && currentIncomerPage === 1)">Next <span class="p-button-icon p-button-icon-left fas fa-forward"></span></button>
      <button mat-raised-button color="warn" (click)="cancel()"><mat-icon>cancel</mat-icon> Cancel</button>
    </div>

    <div *ngIf="showMCCB" class="button-container">
      <button mat-raised-button color="accent" (click)="previous()" *ngIf="currentPage > 1"><span class="p-button-icon p-button-icon-left fas fa-backward"></span> Previous</button>
      <button mat-raised-button style="background-color: #183160; color: white" (click)="previousOutgoings()" *ngIf="outgoingHistory.length > 0 && currentOutGoingPage !== 1" [disabled]="outgoingHistory.length <= 0"><span class="p-button-icon p-button-icon-left fas fa-backward"></span> Previous Outgoing</button>
      <button mat-raised-button style="background-color: #34bc83; color: white" (click)="addOutging()" [disabled]="!matchingRowMCCB"><span class="fa-solid fa-circle-plus"></span> Add Another Outgoing</button>
      <button mat-raised-button color="primary" (click)="nextOutgoingButton()" [disabled]="!matchingRowMCCB">Next <span class="p-button-icon p-button-icon-left fas fa-forward"></span></button>
      <button mat-raised-button color="warn" (click)="cancel()"><mat-icon>cancel</mat-icon> Cancel</button>
    </div>

    <div *ngIf="showProjectDetails" class="button-container">
      <button mat-raised-button color="accent" (click)="previousOutgoing()" *ngIf="currentPage > 1"><span class="p-button-icon p-button-icon-left fas fa-backward"></span> Previous</button>
      <button mat-raised-button style="background-color: #007bff; color: white" *ngIf="projectForm.valid && !myControl.hasError('required')" (click)="onSumbit(false)" matTooltip="Save changes">Save <mat-icon>save</mat-icon></button>
      <button mat-raised-button color="warn" (click)="cancel()"><mat-icon>cancel</mat-icon> Cancel</button>
    </div>
  </div>
</div>
